import { Axios } from "../httpService";

export const ListLetter = () => {
  return Axios.get("/Letter/ListLetterUser");
};
export const ListLetterHead = () => {
  return Axios.get("/Letter/ListSarbargUser");
};
export const ListEmza = () => {
  return Axios.get("/Letter/ListEmzaUser");
};
export const AddLetter = (data) => {
  return Axios.post("/Letter/AddLetter", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const AddLetterHead = (data) => {
  return Axios.post("/Letter/AddSarbarg", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const AddEmza = (data) => {
  return Axios.post("/Letter/AddEmza", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const DownloadLetter = () => {
  return Axios.get("/Letter/DownloadLetter/");
};
export const DeleteLetter = (id) => {
  return Axios.delete(`/Letter/DeleteLetter/${id}`);
};
  export const DeleteLetterHead = (id) => {
    return Axios.delete(`/Letter/DeleteSarbarg/${id}`);
  };
  export const DeleteLetterEmza = (id) => {
    return Axios.delete(`/Letter/DeleteEmza/${id}`);
  };
export const GetLetterById = (id) => {
  return Axios.get(`/Letter/GetLetterById/${id}`);
};
export const EditLetter = (id, data) => {
  return Axios.put(`/Letter/EditLetter`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const EditLetterHead = (id, data) => {
  return Axios.put(`/Letter/EditSarbarg`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const EditEmza = (id, data) => {
  return Axios.put(`/Letter/EditEmza`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
